import React, { useState } from "react";
import { ReportAPI } from "../../api/apiClient";
import { useUI } from "../../context/UIContext";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function EquipmentStatementResourceWiseReport() {

const { selectedProjectId, selectedProjectName } = useUI();

const [startDate,setStartDate] = useState("");
const [endDate,setEndDate] = useState("");
const [rows,setRows] = useState<any[]>([]);
const [loading,setLoading] = useState(false);
const [showReport,setShowReport] = useState(false);
const [expanded,setExpanded] = useState(false);

const formatDate = (d:string) => {
if(!d) return "";
const date = new Date(d);
return date.toLocaleDateString("en-GB",{
day:"2-digit",
month:"short",
year:"numeric"
});
};

const runReport = async () => {

if(!selectedProjectId) return;

setLoading(true);

const data = await ReportAPI.getEquipmentStatementResourceWise({
project: selectedProjectId,
startDate,
endDate
});

setRows(data);
setLoading(false);
setShowReport(true);

};

const grouped:any = {};

rows.forEach(r=>{
if(!grouped[r.componentGroup])
grouped[r.componentGroup] = [];

grouped[r.componentGroup].push(r);
});

const uniqueDates = Array.from(
new Set(rows.map((r:any)=>formatDate(r.date)))
);

const exportPDF = () => {

const pdf = new jsPDF("p","mm","a4");

let y = 15;

pdf.setFontSize(14);
pdf.text(selectedProjectName ?? "",10,y);

y += 6;

pdf.setFontSize(12);
pdf.text("Equipment Statement Resource Wise",10,y);

y += 6;

pdf.setFontSize(10);
pdf.text(`${formatDate(startDate)} to ${formatDate(endDate)}`,10,y);

y += 8;

const body:any = [];

Object.keys(grouped).forEach(group=>{

body.push([
{
content: group,
colSpan: expanded ? 3 + uniqueDates.length + 1 : 4,
styles:{
fillColor:[255,200,200],
fontStyle:"bold"
}
}
]);

grouped[group].forEach((r:any)=>{

const row:any = [
r.component,
r.mobilization,
r.unit
];

if(expanded){
uniqueDates.forEach(()=>{
row.push("");   // <-- FIXED: keep date mobilization columns blank
});
}

row.push("");

body.push(row);

});

});

const head = expanded
?
[
[
"",
"Mobilization",
"Unit",
...uniqueDates,
"Total"
],
[
"Resource",
"Type",
"Unit",
...uniqueDates.map(()=> "Mobilization"),
"Mobilization"
]
]
:
[
[
"",
"Mobilization",
"Unit",
"Total"
],
[
"Resource",
"Type",
"Unit",
"Mobilization"
]
];

autoTable(pdf,{
startY:y,
head:head,
body:body,
theme:"grid",
headStyles:{
fillColor:[30,41,59],
textColor:255
},
styles:{
fontSize:9
},

didDrawPage: function () {

const pageSize = pdf.internal.pageSize;
const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();

const pageNumber = pdf.getNumberOfPages();

pdf.setFontSize(9);

pdf.text(
`Page ${pageNumber}`,
pageWidth - 25,
pageHeight - 10
);

}

});

pdf.save("EquipmentStatementResourceWise.pdf");

};

if(!showReport){

return(

<div className="p-10 max-w-md">

<h2 className="text-xl font-semibold mb-6">
Equipment Statement Resource Wise
</h2>

<div className="mb-2 font-medium">From:</div>

<input
type="date"
value={startDate}
onChange={(e)=>setStartDate(e.target.value)}
className="border px-3 py-2 w-full mb-6 rounded"
/>

<div className="mb-2 font-medium">To:</div>

<input
type="date"
value={endDate}
onChange={(e)=>setEndDate(e.target.value)}
className="border px-3 py-2 w-full mb-8 rounded"
/>

<button
onClick={runReport}
className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition"

>

Run Report </button>

</div>

);

}

return (

<div className="p-8 w-full max-w-none">

<div className="flex justify-end mb-4">
<button
onClick={exportPDF}
className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition"
>
Export PDF
</button>
</div>

<div className="mb-6">

<div className="text-xl font-bold text-gray-900">
{selectedProjectName}
</div>

<div className="text-lg font-semibold text-gray-800">
Equipment Statement Resource Wise
</div>

<div className="text-sm font-bold text-gray-700">
{formatDate(startDate)} to {formatDate(endDate)}
</div>

</div>

<table className="w-full text-sm border-collapse table-fixed">

<thead>

<tr className="text-center font-semibold">

<th className="w-1/3"></th>

<th>Mobilization</th>

<th>Unit</th>

{expanded && uniqueDates.map(d=>(

<th key={d}>{d}</th>
))}

<th>
Total
<button
onClick={()=>setExpanded(!expanded)}
className="ml-2 text-xs bg-gray-200 px-2 rounded"
>
{expanded ? "-" : "+"}
</button>
</th>

</tr>

<tr className="bg-gray-800 text-white text-center">

<th className="text-left px-3 py-2">Resource</th>

<th>Type</th>

<th>Unit</th>

{expanded && uniqueDates.map((_,i)=>(

<th key={i}>Mobilization</th>
))}

<th>Mobilization</th>

</tr>

</thead>

<tbody>

{Object.keys(grouped).map(group => (

<React.Fragment key={group}>

<tr className="bg-red-200 font-semibold">
<td colSpan={expanded ? 4 + uniqueDates.length : 4} className="px-3 py-1">
{group}
</td>
</tr>

{grouped[group].map((r:any,i:number)=>(

<tr key={i} className="border-b">

<td className="pl-6 py-1">
{r.component}
</td>

<td className="text-center">
{r.mobilization}
</td>

<td className="text-center">
{r.unit}
</td>

{expanded && uniqueDates.map(d=>(

<td key={d} className="text-center"></td>
))}

<td></td>

</tr>

))}

</React.Fragment>

))}

</tbody>

</table>

<div className="bg-gray-800 h-4 mt-3"></div>

<div className="mt-6">

<button
onClick={()=>setShowReport(false)}
className="px-5 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"

>

Back </button>

</div>

</div>

);

}
